import { render, staticRenderFns } from "./RegistrationDocument.vue?vue&type=template&id=5f0615da&scoped=true&"
import script from "./RegistrationDocument.vue?vue&type=script&lang=js&"
export * from "./RegistrationDocument.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDocument.vue?vue&type=style&index=0&id=5f0615da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0615da",
  null
  
)

export default component.exports